import { Button, Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoMessage } from '../../common/InfoMessage/InfoMessage';
import { authService } from '../../../services/auth/AuthService';
import { PhoneVerificationForm } from '../PhoneVerificationForm/PhoneVerificationForm';

import { useUser } from '../../../hooks/useUser';

export const PhoneNotConfirmed = ({
  onStatusUpdate,
}: {
  onStatusUpdate: () => Promise<void>;
}) => {
  const [isCodeSent, setIsCodeSent] = useState<boolean>(false);

  const { t } = useTranslation();
  const { user } = useUser();

  const handleSendVerificationCode = async () => {
    setIsCodeSent(true);

    if (user?.phone) {
      await authService.resendCode(user.phone);
    }
  };

  if (isCodeSent)
    return (
      <PhoneVerificationForm
        goToCabinet={false}
        onSubmit={onStatusUpdate}
        offBoxShadow={false}
        descriptionText={
          <>
            {t('userAuth.phoneConfirmation.textPart1')}
            {t('userAuth.phoneConfirmation.textPart2')}
            <br />
            <br />
            {t('userAuth.phoneConfirmation.textPart3')}
          </>
        }
        onResendCode={async () => {
          if (user?.phone) {
            await authService.resendCode(user.phone);
          }
        }}
      />
    );

  return (
    <Stack
      sx={{
        padding: { xs: '0 22px' },
        gap: { xs: '15px' },
        marginTop: { xs: '50px' },
        maxWidth: '400px',
      }}
    >
      <InfoMessage
        type="warning"
        bottomText="noUserPhoneConfirmationBlock.text"
        upperText="noUserPhoneConfirmationBlock.title"
      />
      <Button
        variant="contained"
        onClick={handleSendVerificationCode}
        sx={{ marginTop: { xs: '20px' }, maxWidth: '150px' }}
      >
        {t('noUserPhoneConfirmationBlock.btnText')}
      </Button>
    </Stack>
  );
};
